import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import noImage from '../../../assets/images/no-image.png';
import { checkStatus, shortenandHoverString } from '../../helper';

const isBase64 = (element) => element.image;

const isSelected = (selectedIds, item) => {
  return selectedIds.filter((val) => val === item._id).length > 0;
};

const imgSrc = (element) => element?.image || noImage;

const posterSrc = (element) => {
  return element?.image ? isBase64(element) : imgSrc(element);
};

function TestingGroupCard({
  item,
  index,
  onCheck,
  onDelete,
  editeble,
  selectedIds,
  isImport,
  handleLinkAge,
  handleImportLib,
  isSupplierLoggedIn,
  isProductArchived,
  testingAddEditAccess,
  testingDeleteAccess,
}) {
  const [element, setElement] = useState(null);
  const [showCreatedBy, setShowCreatedBy] = useState(false);
  const isChecked = isSelected(selectedIds, item);
  const { t } = useTranslation('common');

  useEffect(() => {
    // effect
    const value = item ? { ...item } : null;
    setElement(value);
  }, [item]);

  return (
    <div id="accordion" className="col-lg-3 item-list" key={index}>
      <div className="common-listing-card card mt-5 mb-16">
        <div className="card-header">
          {!isSupplierLoggedIn && !isProductArchived && (
            <ul className="card-header-icon">
              {testingAddEditAccess || testingDeleteAccess ? (
                <li>
                  <div className="common-checkbox">
                    <input
                      onChange={(e) => {
                        onCheck(e, item._id, index);
                      }}
                      name={`check_${index}`}
                      id={`check_${index}`}
                      type="checkbox"
                      checked={isChecked}
                    />
                    <label htmlFor={`check_${index}`} className="chklabel" />
                  </div>
                </li>
              ) : (
                ''
              )}
              {isImport && (
                <li>
                  <button
                    type="button"
                    className="btn btn-action-icon m-0"
                    aria-label="update-library"
                    title={t('TESTING_GROUP_CARD.ADD_UPDATE_LIBRARY')}
                    onClick={() => handleImportLib(element._id)}
                  >
                    <i className="icon-Library-1" />
                  </button>
                </li>
              )}
              {editeble && testingAddEditAccess && (
                <li>
                  <Link
                    title={t('TESTING_GROUP_CARD.EDIT')}
                    className="cursor-pointer text-dark text-decoration-none "
                    to={`/libraries/testing-group/edit/${element?._id}`}
                  >
                    <i className="icon-Edit-1" />
                  </Link>
                </li>
              )}
              {testingDeleteAccess && (
                <li>
                  <button
                    type="button"
                    className="btn btn-action-icon m-0"
                    title={t('TESTING_GROUP_CARD.DELETE')}
                    aria-label={t('TESTING_GROUP_CARD.DELETE')}
                    onClick={() => onDelete(element._id)}
                  >
                    <i className="icon-Delete" />
                  </button>
                </li>
              )}
              {isImport && (
                <li>
                  <button
                    type="button"
                    className="btn btn-action-icon m-0"
                    title={t('TESTING_GROUP_CARD.LINKAGE')}
                    aria-label={t('TESTING_GROUP_CARD.LINKAGE')}
                    onClick={() => handleLinkAge(element._id)}
                  >
                    <i className="icon-Link-Bold-2 f-24" />
                  </button>
                </li>
              )}
            </ul>
          )}
          <div className="image-detail">
            <div
              className="card-image-preview"
              style={{
                backgroundImage: `url(${posterSrc(item)})`,
              }}
            />
            <span
              className="big-image"
              style={{
                backgroundImage: `url(${posterSrc(item)})`,
              }}
            />
          </div>
        </div>
        <div className="card-body" onClick={() => setShowCreatedBy(!showCreatedBy)}>
          <h4 className="title">{element?.name ? shortenandHoverString(element?.name, 20) : ''}</h4>
          <ul className="card-ul">
            <li>
              <strong>{t('TESTING_GROUP_CARD.GROUP_DESCRIPTION')}: </strong>
              {element?.description && shortenandHoverString(element?.description, 40)}
            </li>
            {showCreatedBy && (
              <li>
                <strong>{t('TESTING_GROUP_CARD.CREATED_BY_DATE_TIME')}: </strong>
                {element?.createdBy && (
                  <span>
                    {element?.createdBy} {element?.createdAt && moment(element?.createdAt).format('DD-MMM-YYYY, HH:mm:ss a')}
                  </span>
                )}
              </li>
            )}
            {showCreatedBy && (
              <li>
                <strong>{t('TESTING_GROUP_CARD.MODIFIED_BY_DATE_TIME')}: </strong>
                {element?.modifiedBy && (
                  <span>
                    {element?.modifiedBy} {element?.lastModifiedAt && moment(element?.lastModifiedAt).format('DD-MMM-YYYY, HH:mm:ss a')}
                  </span>
                )}
              </li>
            )}
          </ul>
        </div>
        {isImport && <div className={`status ${checkStatus(element)}`} />}
      </div>
    </div>
  );
}

export default TestingGroupCard;
